/**
 * Darf dieser Nutzer beim Anlegen eines Projekts die Aufnahme nach KA WÄHLEN?
 *
 * Solange die KA-Aufnahme im Bau ist (es gibt noch keine Schlüssellisten), nur
 * Entwickler, und zwar in JEDER Ausgabe der App (Nutzer-Entscheidung 21.09.2026).
 * Alle anderen sehen den Abschnitt „Kartierverfahren" gar nicht; ihre Projekte
 * laufen nach SEA 95.
 *
 * Bis zum 21.09.2026 hing die Freigabe am Bau (`!environment.production`): in
 * Entwicklungs-Ausgaben für alle, in der Produktion für niemanden. So kam die
 * KA6-Eingabe mit bpweb 2.4.12 zwar mit, ließ sich dort aber nicht erreichen.
 *
 * Die Regel betrifft allein das ANLEGEN. Gelesen wird ein KA-Punkt für jeden
 * richtig (`verfahrenVon`): Wer Mitglied in einem KA-Projekt ist, sieht dessen
 * Punkte mit der KA-Maske, wie er jeden anderen Punkt des Projekts sieht.
 *
 * Das ist die EINZIGE Stelle, an der die Freigabe steht. Gefragt wird sie über
 * `VERFAHREN_SECTION.sichtbar`, bei jedem Öffnen des Fensters neu: Die Rolle
 * steht erst nach der Anmeldung fest. Wenn die KA-Aufnahme fertig ist: hier
 * `true` zurückgeben (oder `sichtbar` am Abschnitt ganz entfernen).
 */
export function kaAufnahmeWaehlbar(auth: { canIbe(role: string): boolean } | null | undefined): boolean {
	return auth?.canIbe('entwickler') === true;
}
